import { Fragment, useRef } from "react";
import { useDiorama } from "../contexts/DioramaContext";
import CharacterPreview from "./wizard/CharacterPreview";

const DioramaPreview: React.FC = () => {
	const { state } = useDiorama();
	const { background, characters, text } = state;

	const fontColor = "#444";

	// Add this missing ref for character DOM elements
	const characterRefs = useRef<Record<string, HTMLDivElement | null>>({});
	return (
		<div
			className={`relative w-full border-2 border-black rounded-b-lg bg-gray-800 text-white`}
		>
			{background && (
				// <div className="">
				<img
					src={background.image}
					alt="Background"
					className="object-right-bottom"
				/>
				// </div>
			)}

			{/* Characters */}
			{characters.map((char) => (
				<div
					key={char.id}
					className="absolute character-item"
					style={{
						right: `${char.slot.position.x}%`,
						bottom: `${char.slot.position.y}%`,
						// width: `${char.customization?.template.width}px`,
						// height: `${char.customization?.template.height}px`,
						// width: "25px",
						// height: "40px",
					}}
					ref={(el) => {
						characterRefs.current[char.id] = el;
					}}
				>
					{char.customization ? (
						<CharacterPreview
							template={char.customization.template}
							skinTone={char.customization.skinTone}
							top={char.customization.top}
							bottom={char.customization.bottom}
							accessories={char.customization.accessories}
							iris={char.customization.irisColor}
							hair={char.customization.hair}
							size="sm"
							castShadow={true}
						/>
					) : (
						<img
							src={char.image}
							alt="Character"
							className="w-full h-full object-contain"
						/>
					)}
				</div>
			))}

			{/* Text */}
			{text && state.currentStep > 2 && (
				<div
					className="absolute bottom-5 md:bottom-12 xl:bottom-15 left-1/2 transform -translate-x-1/2 text-left px-10 py-2 rounded w-3/4 text-sm break-words"
					style={{
						color: fontColor,
						whiteSpace: "pre-wrap",
					}}
				>
					{text.split("\n").map((line, i) => (
						<Fragment key={i}>
							{line}
							<br />
						</Fragment>
					))}
				</div>
			)}

			{/* Empty state */}
			{!background && characters.length === 0 && (
				<div className="h-full p-5 md:p-10 m text-xl">
					<p className="mb-4">
						The <strong>Gamerfinds Pixellize</strong> is a fun and interactive
						tool that lets you create your own personalized diorama scenes.
						Start by selecting a background for your scene, then add and
						customize characters by choosing their skin tone, hair, clothing,
						and accessories. You can also add text to your diorama to make it
						uniquely yours. Once you're happy with your creation, you can
						preview it, share it to us with a link. We will use your creation as
						a reference to the actual diorama you're ordering.
					</p>
					<p className="mb-4">
						To get started, simply follow the step-by-step wizard, and let your
						creativity shine!
					</p>
				</div>
			)}
		</div>
	);
};

export default DioramaPreview;
